import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const FivePointStarAlt = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="83" viewBox="0 0 83 79" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M41.8343 0.297249L56.2909 23.5849L82.9059 30.1379L65.2256 51.0822L67.2186 78.4201L41.8343 68.0771L16.4509 78.4201L18.4439 51.0822L0.763535 30.1379L27.3786 23.5849L41.8343 0.297249Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
